import { FC } from "react";
import styled, { css } from "styled-components";
import { DateTime } from "luxon";

import Text from "@/components/Text";
import { ImageDistributionStatus } from "@/utils/enums";

const Badge = styled.div<{ $status: ImageDistributionStatus }>`
  height: 27px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  ${({ theme, $status }) =>
    $status === ImageDistributionStatus.POSTED &&
    css`
      background: ${theme.colors.success};
    `}
  ${({ theme, $status }) =>
    $status === ImageDistributionStatus.SCHEDULED &&
    css`
      background: ${theme.colors.info};
    `}
    ${({ theme, $status }) =>
    $status === ImageDistributionStatus.DRAFT &&
    css`
      background: ${theme.colors.darkGray};
    `}
`;

interface Props {
  status: ImageDistributionStatus;
  postDate?: string;
}

const StatusBadge: FC<Props> = ({ status, postDate }) => {
  const now = DateTime.now();

  const getStatus = () => {
    if (status === ImageDistributionStatus.DRAFT) {
      return ImageDistributionStatus.DRAFT;
    }
    if (status === ImageDistributionStatus.POSTED) {
      if (DateTime.fromISO(postDate!) > now) {
        return ImageDistributionStatus.SCHEDULED;
      }
      return ImageDistributionStatus.POSTED;
    }
    return ImageDistributionStatus.DRAFT;
  };

  const postStatus = getStatus();

  const renderStatusName = () => {
    switch (postStatus) {
      case ImageDistributionStatus.POSTED:
        return "Posted";
      case ImageDistributionStatus.SCHEDULED:
        return "Scheduled";
      case ImageDistributionStatus.DRAFT:
        return "Draft";
    }
  };

  return (
    <Badge $status={postStatus}>
      <Text $type="smallHeadline" $color="white">
        {renderStatusName()}
      </Text>
    </Badge>
  );
};

export default StatusBadge;
